module.exports = __webpack_public_path__ + "img/net-fail.9d158533.png";